import {Image, Text, TouchableOpacity, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import {formatDateToLocaleDate} from 'helpers/dateFormat';

export interface DayNavigationForWebProps {
  currentDay: Date;
  onPressPrevDay(): void;
  onPressNextDay(): void;
}

const DayNavigationForWeb = (props: DayNavigationForWebProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);
  return (
    <View style={styles.dayNavigationContainerStyle}>
      <View style={styles.dayNavigationTitleWrapper}>
        <Text style={styles.dayNavigationTitleStyle}>
          {formatDateToLocaleDate(props.currentDay)}
        </Text>
      </View>

      <View style={styles.buttonContainerStyle}>
        <TouchableOpacity
          activeOpacity={0.6}
          onPress={props.onPressPrevDay}
          style={styles.buttonStyle}>
          <Image
            source={theme.images.arrowLeft}
            resizeMode="contain"
            style={styles.imageStyle}
          />
        </TouchableOpacity>

        <TouchableOpacity
          activeOpacity={0.8}
          onPress={props.onPressNextDay}
          style={styles.buttonStyle}>
          <Image
            source={theme.images.arrowRight}
            resizeMode="contain"
            style={styles.imageStyle}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default DayNavigationForWeb;
